import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@cart-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

// impression event
export const croutonImpressionEvent = (
    crazyDealsExpiryMsg: string,
    impressionEvent: AnalyticsContextValue["impressionEvent"],
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        context: crazyDealsExpiryMsg,
        action: IMPRESSION_ACTIONS.IMPRESSION_TOAST_CROUTON,
    });
};
